import { HTTPStatusCodes } from '@omnipresentgroup/constants';
import { HttpResponse, http } from 'msw';

import { API_BASE, BENEFITS_API_PATH } from './constants';
import { DEFAULT_BENEFITS } from './fixtures';

export const benefitsHandlers = [
  http.get(`*${API_BASE}/${BENEFITS_API_PATH}`, () =>
    HttpResponse.json(DEFAULT_BENEFITS, {
      status: HTTPStatusCodes.OK,
    }),
  ),
];
